import { EvaluacionType } from "#competence/constants"
import { ContextsQuestionProvider } from "#competence/contexts/ContextsQuestion"
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp"
import { Stack } from "@mui/material"
import MuiAccordion from "@mui/material/Accordion"
import MuiAccordionDetails from "@mui/material/AccordionDetails"
import MuiAccordionSummary, {
	accordionSummaryClasses,
} from "@mui/material/AccordionSummary"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import CompetenceQuestion from "../question/CompetenceQuestion"
import CompetenceQuestionDelete from "../question/CompetenceQuestionDelete"
import CompetenceQuestionForm from "../question/CompetenceQuestionForm"
import { CompetenceQuestionInfoDialog } from "../question/CompetenceQuestionInfo"
import CompetenceInfoDimension from "./CompetenceInfoDimension"

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	"&:not(:last-child)": {
		borderBottom: 0,
	},
	"&::before": {
		display: "none",
	},
}))

const AccordionSummary = styled((props) => (
	<MuiAccordionSummary
		expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
		{...props}
	/>
))(({ theme }) => ({
	backgroundColor: "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	[`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
		{
			transform: "rotate(90deg)",
		},
	[`& .${accordionSummaryClasses.content}`]: {
		marginLeft: theme.spacing(1),
	},
	...theme.applyStyles("dark", {
		backgroundColor: "rgba(255, 255, 255, .05)",
	}),
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: "2px solid rgba(0, 0, 0, .125)",
}))

const CustomAccordion = styled(Accordion)(({ theme }) => ({
	borderRadius: theme.shape.borderRadius * 2, // 16px si el default es 8px
	boxShadow: theme.shadows[4],
	overflow: "hidden",
	backgroundColor: "white",
}))
export default function CustomizedAccordions() {
	const [expanded, setExpanded] = useState("panel2")

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false)
	}

	return (
		<ContextsQuestionProvider>
			<Stack spacing={1}>
				<CustomAccordion
					expanded={expanded === "panel2"}
					onChange={handleChange("panel2")}
				>
					<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
						<Typography component="span">Dimensiones</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<CompetenceInfoDimension />
					</AccordionDetails>
				</CustomAccordion>

				<CustomAccordion
					expanded={expanded === "panel1"}
					onChange={handleChange("panel1")}
				>
					<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
						<Typography component="span">Preguntas Entrevista</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<CompetenceQuestion type={EvaluacionType.ENTREVISTA} />
					</AccordionDetails>
				</CustomAccordion>

				<CustomAccordion
					expanded={expanded === "panel3"}
					onChange={handleChange("panel3")}
				>
					<AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
						<Typography component="span">Preguntas Evaluacion Desempeño</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<CompetenceQuestion type={EvaluacionType.PERFORMANCE} />
					</AccordionDetails>
				</CustomAccordion>
			</Stack>
			<CompetenceQuestionForm />
			<CompetenceQuestionInfoDialog />
			<CompetenceQuestionDelete />
		</ContextsQuestionProvider>
	)
}
